export const bg = {
    idle1: 'Страхотно предложение!',
    idle2: 'Време е да наддавате!',
    idle3: 'Не го пропускайте!',
    idle4: 'Последна възможност за наддаване!',
    seconds: '{value} секунди до край на наддаването!',
    fairwarningclose: 'Внимание! Наддаването за този лот е към своя край.',
    error: 'Срещнахме грешка. Съжаляваме за неудобството. Mоля, опитайте отново след малко, наддавания',
    bids: {
        current: 'Текуща цена',
        ask: 'Искана цена',
        bid: 'Наддаване',
        bid_warn: 'Внимание! Наддаване',
        highest: 'Вашето наддаване със сумата от {value} EUR е най-високо ',
        sent: 'Вашата оферта от {value} EUR е изпратена.',
        wait: 'Изчакайте наддаването да започне!',
        sold: 'Продадено!',
        congrats: 'Честито!',
        pass: 'Следващ лот!',
        received: 'Вашата оферта от {value} е приета!',
        confirmation: 'Вие сте на път да наддавате',
        confirmation_info: 'Сигурни ли сте, че искате да наддавате за лота?',
        hold: 'Продължете да държите бутона, за да наддавате...',
        outbid: 'Вашата оферта беше надхвърлена!',
        more: 'или предложете повече',
        is_bidding: 'Вашата оферта се изпраща...',
    },
    account: {
        review: 'Прегледайте акаунта си!',
        login: 'Влезте, за да наддавате!',
        your_paddle: 'Вашият номер за наддаване е',
        status_asteptare: 'Изчакване на потвърждение',
        aprobat: 'Акаунтът е одобрен',
        neaprobat: 'Неодобрен акаунт',
    },
    lots: {
        prev: 'Предишен',
        next: 'Следващ',
        no_results: 'Няма резултати за',
        no_more_lots: 'Няма повече лотове за показване',
        sold: 'Продадено',
        pass: 'Пропуснат',
        withdrawn: 'Изтеглен',
        sold_post: 'Продаден след търг',
        open: 'Отворен за наддаване',
        recalled: 'Въведен отново',
        support: 'Поддръжка на живо в',
        search_lots: 'Търсете лотове'
    },
    lot: {
        recall: 'Въвеждане отново',
        recalled: 'Заявката за въвеждане отново е изпратена',
        absentee: 'Неприсъствена оферта',
        absentee_sent: 'Изпратена е неприсъствена оферта',
        reminder: 'Напомняне за наддаване',
        details: 'Подробности',
        next: 'Следващ'
    },
    general: {
        lot: 'Лот',
        est: 'Прогн',
        sp: 'НЦ', // 'Starting price//Начална цена',
        close: 'Затваряне',
        deactivate: 'Деактивирайте',
        cancel: 'Отказ',
        loading: 'Зареждане',
        standby: 'В готовност! Търгът започва!',
        break: 'Търгът е на пауза! Моля, изчакайте!',
        ended: 'Търгът приключи! Благодарим Ви за участието!',
        back_to_current: 'Обратно към търга\ текущ лот на търга',
        room_view: 'Превключване към изглед на зала',
        standard_view: 'Превключване към стандартен изглед',
        turn_on_sound: 'Включете звука',
        turn_off_sound: 'Изключете звука',
        mute_video: 'Заглушаване на видеото',
        unmute_video: 'Включване на звука на видеото',
        mute_sounds: 'Заглушаване на звука',
        unmute_sounds: 'Включване на звука',
        redirect_home: 'Ще бъдете пренасочени към началната страница след {seconds} секунди...',
        redirect_old: 'Ще бъдете пренасочени към приложението Artmark Live след {seconds} секунди..',
        redirect_now: 'Пренасочи ме сега!',
        reload_all: 'приложението ще се презареди след {seconds} секунди...',
        reload_now: 'Презареди сега!',
        welcome: 'Bine ați venit pe pagina de licitații A10 by Artmark! Vă aflați la un pas de adjudecarea loturilor dorite. Succes!',
        ok: 'Ok',
        contact_1: '<a href="tel:+40 736 381 178" class="underline">+40 736 381 178</a>',
        contact_2: '<a href="tel:+40 758 056 113" class="underline">+40 758 056 113</a>',
    },
    modals: {
        send_offer: 'Направете вашата оферта',
        send_offer_details: 'Изберете максималната сума, която искате да предложите. Ние ще наддаваме от ваше име до посочената от вас сума, без да я надвишаваме',
        send_absentee_bid: 'Изпратете неприсъствена оферта',
        maximum_amount: 'Максимална сума',
        bid_more: 'Предложете по-висока сума',
        bid_more_details: 'Сигурни ли сте, че искате да предложите ',
        bid_more_confirmation: 'Направете избраната оферта',
        recall_title: 'Въведете отново',
        recall_details: 'Сигурни ли сте, че искате да въведете лота отново в търга {lot}, {description}? Ние автоматично ще наддаваме от ваше име, за ',
        recall_reserve: 'Запазената цена е ',
        recall_starting_prince: 'Началната цена е ',
        recall_continue: 'Искате ли да продължите?',
    },
    messages: {
        lot_announce: 'Lot {lot}',
        lot_open: 'Bidding has started! Offer now for {ask} EUR!',
        lot_open_winner: 'The current price of the lot is {curent} EUR offered by {paddle}',
        lot_reserve: 'The reserve price of {value} EUR is yours!',
        lot_sell_congrats: 'Congratulations! The lot is yours.',
        lot_sell: 'Lot sold!',
        lot_pass: 'Next lot',
        lot_pass_reserve: 'The reserve price was not reached. Next lot',
        lot_reset: 'Lot {lot}',
        bid_win_congrats: 'You won the bid at {value} EUR!',
        bid_win: '{paddle} won the bid at {ask} EUR',
        bid_outbid: 'You have been outbid!',
        price_changed: 'The current price of the lot is {price} EUR',
        ask_changed: 'The asking price is now {ask} EUR',
        bid_receive: '{paddle} offered {ask} EUR',
        lot_warn: 'Fair warning, last chance...',
        lot_warn_fairwarningclose: 'Fair warning, last chance...',
        lot_warn_once: 'Once...',
        lot_warn_twice: 'Twice...',
        lot_warn_seconds: '{seconds} seconds left...',
        // lot_recall: 'The recall of lot {lot} has been requested',
        lot_recall: 'The recall of lot {lot} has been requested by {paddle}'
    },
    timer: {
        days: 'дни',
        hours: 'часа',
        minutes: 'минути',
        seconds: 'секунди',
    }
}
